module.exports = __webpack_public_path__ + "img/lakkozasi-eljarasok-thumb.510b39c7.jpg";